import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import AuthGuard from './components/AuthGuard';
import { AuthProvider } from './contexts/AuthContext';
import { getBaseOriginUrl, getBasePath } from './utils/basePath';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN;
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE;

const isLocalDev = !auth0Domain || !auth0ClientId;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {isLocalDev ? (
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    ) : (
      <Auth0Provider
        domain={auth0Domain}
        clientId={auth0ClientId}
        authorizationParams={{
          redirect_uri: getBasePath() === '/' ? window.location.origin : getBaseOriginUrl(),
          audience: auth0Audience,
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        useRefreshTokensFallback={true}
      >
        <QueryClientProvider client={queryClient}>
          <AuthGuard>
            <AuthProvider>
              <App />
            </AuthProvider>
          </AuthGuard>
        </QueryClientProvider>
      </Auth0Provider>
    )}
  </React.StrictMode>
);
